export const engLocalizedStrings = {
  GlobalLabels: {
    All: "All",
    Logout: "Log out",
    PleaseWait: "Please wait...",
    Status: "Status",
    Phone: "Phone Number",
    Actions: "Actions",
    Active: "Active",
    Inactive: "Inactive",
    Deleted: "Delete",
    IsDeleted: "Deleted",
    Search: "Search",
    Redo: "Refresh Filters",
    Cancel: "Back",
    Confirmed: "Confirm",
    Detail: "Details",
    Create: "Add",
    Password: "Password",
    PasswordConfirmed: "Confirm Password",
    Description: "Description",
    Update: "Update",
    Address: "Address",
    Partner: "Partner",
    Total: "Total",
    NoPartner: "Not a partner",
    createdAt: "Created date",
    updatedAt: "Updated date",
    Cover: "Background image",
    Success: "Success",
    Failed: "Failed",
    Date: "Day",
    ExcelExporting: "Export Excel",
    Type: "Type",
    Regions: "Regions",
    Login: "Login",
    NoInfo: "No information",
    NoSort: "Not according to priority",
    Day: "Day",
    ManyDays: "Days",
    Hour: "Hour",
    ManyHours: "Hours",
    ASC: "Ascending",
    DESC: "Descending",
    Save: "Save",
    Male: "Male",
    Female: "Female",
    Next: "Next",
    Yes: "Yes",
    No: "No",
    ReloadImages: "Reload images",
    NoImage: "No image",
    Row: "Row",
    Error: "Errors",
    FileList: "File list",
    Currency: "Currency",
    Note: "Note",
    Config: "Config",
    Name: "Name",
    Code: "Code",
  },
  GlobalMessage: {
    UpdateSuccessfully: "Updated successfully!",
    UpdateFailed: "Updated failed:",
    CreateSuccessfully: "Created successfully!",
    CreateFailed: "Created failed:",
    DeleteSuccessfully: "Delete successfully!",
    DeleteFailed: "Delete failed:",
    DeleteConfirmation: "Confirm deleting this element?",
    ResetPassSuccessfully: "Reset password successfully!",
    ResetPassFailed: "Reset password failed:",
    Error: "An error occurred, please try again!",
    Exporting: "Exporting Report...",
    SystemError:
      "Error retrieving login information, returning to login page...",
    LoginSuccessfully: "Login successfully!",
    InvalidAccount: "Invalid username or password or User does not exist!",
    InvalidMenuConfig: "Error in getting Sidebar Menu, please try again later!",
    Failed: "Failed",
    RequiredBrightness: "Minimum required brightness score is 102",
    PleaseFill: "Please enter ",
    RightClickCopy: "Right click to copy",
  },
  GlobalPlaceholder: {
    UserName: "Please enter user name...",
    Email: "Please enter email...",
    Name: "Please enter name...",
    Code: "Please enter code...",
    Partner: "Please select partner",
    Status: "Please select status",
    Phone: "Please enter phone number...",
    Password: "Please enter password",
    PasswordConfirmed: "The confirmation password must match the password",
    Description: "Please enter a description in words",
    InvalidValue: "Please fill in all required information",
    Type: "Please choose type",
    Date: "Please select date",
    InvalidPartnerRole: "Please choose a Role for user",
  },
  Sidebar: {
    General: "Overview",
    Management: "Management",
    History: "Transaction History",
    DataTransaction: "Package",
    SystemConfig: "System Configuration",
    DataPackages: "Data Package",
    RoamingPackages: "Roaming Package",
    UserManagement: "User",
    AffiliateManagement: "Affiliate Management",
    OrderList: "Sim Purchase Order",
    TravelSimList: "Travel Sim Registration",
    Country: "Country",
    PlatformConfig: "Platform",
    Contents: "Post",
    Files: "Files",
    CDN: "CDN",
    Address: "Province",
  },
  General: {
    Revenue: {
      Day: "Today's Revenue",
      Week: "This Week's Revenue",
      Month: "This Month's Revenue",
      LastMonth: "Last Month's Revenue",
      WeekOfYear: "Week",
    },
    Charts: {
      Title: "Summary Report",
      Transaction: "Transaction",
      TotalRevenue: "Total Revenue",
      SuccessTransaction: "Total Successful Transactions",
    },
  },
  UserManagement: {
    MainTitle: "User Management",
    Total: "Total User",
    Columns: {
      UserName: "Username",
      FullName: "Full Name",
      Email: "Email",
      Partner: "Partner",
      Phone: "Phone Number",
      Balance: "Balance",
      Role: "Role",
      ResetPass: "Set New Password",
      OldPass: "Old Password",
      NewPass: "New Password",
      Currency: "Unit",
    },
    RuleMessage: {
      Url: "Please enter the link as HTTPS URL",
      Name: "Please enter the name",
      Password: "Please enter the password",
      UserName: "Please enter the username",
      IdUrl: "Please enter the marketing link",
      IconUrl: "Please enter the icon link in jpg, png, jpeg format",
      Status: "Please select the status",
      Phone: "Please enter the 10-digit phone number",
      Code: "Please enter the code",
      Role: "Please select the role for the user",
      Partner: "Please select a partner",
      InvalidPartner: "Invalid partner",
      Balance: "Please enter the limit",
      ResetYourAccount: "Your password has been changed, directing to Login...",
    },
    UserType: {
      Normal: "Basic user",
      SuperAdmin: "Super admin",
      Partner: "Partner",
    },
  },
  PathConfigManagement: {
    Title: "Configuration Management",
    Total: "Total",
    Columns: {
      Title: "Configuration Name",
      Code: "Configuration Code",
      Path: "Path",
      ImageUrl: "Image",
      Description: "Description",
    },
    Placeholder: {
      Title: "Please enter name",
      Path: "Please enter path",
      ImageUrl: "Please enter image URL",
      Description: "Please enter description",
    },
    Message: {
      AddConfig: "Please declare JSON configuration below",
    },
  },
  ContentManagement: {
    Title: "Manage posts",
    Total: "Total posts",
    Columns: {
      Name: "Post name",
      Preview: "Preview",
      Replace: "Replace posts",
      Download: "Download posts",
      Delete: "Delete posts",
      File: "Post files",
      Image: "Image",
    },
    Message: {
      WrongStructure: "The uploaded file is not in the correct format!",
      NotExisted: "The uploaded file does not exist!",
      Files: "Please enter at least one post file",
      OnlyDocx: "Note: Only enter DOCX files",
      OnlyImages: "Note: Only enter 1 PNG, JPEG, JPG image file",
      MissingAttributes:
        "Please name the post file with the prefix Content for DOC files or Image for image files!",
      AddAttribute:
        "Please name the post file with the prefix Content (Content_abc.docx), image file with prefix Image (Image_xyz.png)",
    },
  },
  CountryManagement: {
    Title: "Country Management",
    Total: "Country Total",
    Columns: {
      Name: "Country Name",
      Code: "Country Code",
      Capital: "Capital",
      Region: "Region",
      Ensign: "Flag",
    },
    Regions: {
      SouthAmerica: "South America",
      NorthAmerica: "North America",
      NorthPole: "Antarctica",
      Europe: "Europe",
      Asia: "Asia",
      Africa: "Africa",
      Australia: "Oceania",
      Asean: "Southeast Asia",
    },
    Placeholder: {
      Capital: "Please enter the capital name",
      Region: "Please select the country region",
      Cover: "Please enter the image link as URL",
    },
    RoamingPartner: {
      Name: "Partner Name",
      Code: "Partner Code",
    },
    MobileData: {
      Name: "Package Name",
      Code: "Package Code",
      Price: "Package Price",
      Handset: "Handset",
      TransferredData: "Data Group",
      CodeMobileDevice: "Mobile Device Code",
    },
    Message: {
      CoverAttributes: "Please name the cover file with the prefix Cover_",
      EnsignAttributes: "Please select a national flag image file!",
    },
  },
  FileManagement: {
    Title: "CDN Management",
    Upload: "Import File",
    Replace: "Replace File",
    Download: "Download File",
    CopyUrl: "Copy URL",
    Placeholder: {
      Type: "Please select file type",
      File: "Please import at least 1 file from your computer",
      Url: "Saved URL to clipboard",
    },
    Columns: {
      Name: "File name",
      Code: "File code",
      Size: "Size",
      Type: "File type",
    },
  },
  BalanceHistory: {
    Title: "Balance Adjustment History",
    Approve: "Approve",
    Reject: "Reject",
    Transaction: "Transactions",
    SearchWith: "Search with",
    Add: "Create Top-up Voucher",
    Type: {
      0: "Increase Voucher",
      1: "Decrease Voucher",
      2: "Refund Voucher",
    },
    Status: {
      0: "Pending Approval",
      1: "Approved",
      2: "Rejected",
      3: "Error",
    },
    ApplicableType: {
      0: "User",
      1: "Partner",
    },
    WalletType: {
      0: "Domestic Currency",
      1: "Foreign Currency",
    },
    TransactionInfo: {
      createdAt: "Created At",
      updatedAt: "Updated At",
      code: "Transaction Code",
      transRef: "Referenced Code",
      packageCode: "Package Code",
      network: "Carrier",
      totalAmount: "Total Amount",
      partner: "Partner",
      owner: "Owner",
      status: "Status",
    },
    Placeholder: {
      Type: "Please select voucher type",
      ApplicableType: "Please select applicable object",
      Amount: "Please enter the requested amount larger than 0",
      Phone: "Please select user or partner information",
      Partner: "Please select a partner",
      User: "Please select a user",
      Approve: "Approve this ticket",
      Reject: "Reject this ticket",
      UseDotForDecimals: "Use a period (.) for typing decimal currency",
      Transaction: "Enter transaction code for reference code",
    },
    Columns: {
      createdAt: "Created Date",
      updatedAt: "Updated Date",
      code: "Voucher Code",
      userName: "Username",
      phone: "Phone Number",
      fullName: "Full Name",
      email: "Email",
      address: "Address",
      userType: "User Type",
      walletType: "Wallet Type",
      before: "Balance before approval",
      after: "Balance after approval",
      amount: "Requested Amount",
      wallet: "Current Balance",
      applicableType: "Applicable Subject",
      type: "Type",
      status: "Status",
      createdBy: "Creator",
      updatedBy: "Approver",
      description: "Description",
      reason: "Reason for creating ticket",
      transaction: "Related Transaction",
    },
    Message: {
      CreateSuccessfully: "Created voucher successfully!",
      CreateFailed: "Created voucher failed!",
      ApproveSuccessfully: "Approved voucher successfully!",
      ApproveFailed: "Approved voucher failed!",
      RejectSuccessfully: "Rejected voucher successfully!",
      RejectFailed: "Rejected voucher failed!",
      DirectToHistory: "Balance adjusment history",
      NeedTransaction: "Refund tickets need a valid transaction",
      NotFoundTransaction:
        "Cannot find transaction data belongs to this individual",
    },
  },
  RoamingManagement: {
    Title: "Roaming Package Management",
    Total: "Total Roaming Package",
    Add: "Add",
    Category: {
      Hot: "Hot Package",
      Day: "Daily Package",
      Week: "Weekly Package",
      Month: "Monthly Package",
      Roaming: "Roaming Package",
    },
    PlaceHolder: {
      Cover: "Please enter image url...",
      Descriptions: "Please enter description...",
      ShortDes: "Please enter short description...",
      Duration: "Please enter package duration...",
      Price: "Please enter package price...",
      Storage: "Please enter package capacity...",
      DiscountRate: "Please enter discount...",
      InternalCallTotalHour: "Please enter domestic call hours...",
      ExternalCallTotalHour: "Please enter international call hours...",
      Category: "Please select package type...",
      Country: "Please select country...",
    },
    Country: {
      Title: "Country",
      Add: "Add country",
      Edit: "Edit country information",
    },
    RoamingPartner: {
      Title: "Partner",
      Add: "Add partner",
      Select: "Select partner",
    },
    Columns: {
      Name: "Name package",
      Code: "Code",
      Cover: "Image",
      Description: "Description",
      ShortDescription: "ShortDescription",
      Duration: "Package Duration",
      Price: "Price",
      Storage: "Storage",
      DiscountRate: "Discount",
      InternalCallTotalHour: "Internal Call Hours",
      ExternalCallTotalHour: "Outside Call Hours",
      Action: "Action",
      Country: "Country",
      Region: "Region",
      Category: "Package Type",
      Order: "Order",
      Type: "Type",
      SimType: "Sim Type",
    },
  },
  TopupManagement: {
    Title: "Data Package Management",
    Total: "Total Package",
    Add: "Add Information",
    AddShort: "Add Short Description",
    AddMore: "Add Package Details",
    More: "Package Details",
    MoreInfoName: "Information Name",
    MoreInfoItems: "Information",
    ShortDescription: "Short Description",
    Columns: {
      Name: "Name",
      Code: "Code",
      DurationDay: "Duration",
      Price: "Price",
      Storage: "Capacity",
      Category: "Type",
      Order: "Order point",
      InternalCallTotalHour: "Domestic Calls",
      ExternalCallTotalHour: "Foreign Calls",
    },
    Category: {
      Hot: "Hot Package",
      Day: "Daily Package",
      Week: "Weekly Package",
      Month: "Monthly Package",
    },
    Placeholder: {
      DurationDay: "Please Enter package duration",
      Price: "Please enter the lowest package price of 1,000 VND!",
      Storage: "Please enter the capacity as a number!",
      Cover: "Please enter the image link as a URL!",
      Category: "Please select a package type",
    },
    SyncFromB2B: {
      Title: "Add data package from B2B",
      Confirm: "Are you sure you want to add packages",
      InvalidPackages: "Please select a package",
    },
  },
  TransactionHistory: {
    Title: "Package transaction history",
    Total: "Total transactions",
    NoTransRef: "No reference code",
    UpdateStatus: "Update status",
    UpdateStatusSuccess: "Update status successfully",
    Customer: "Retail customers",
    Details: "Transaction details",
    Message: {
      PartnerListError: "Partner list error",
    },
    Status: {
      Init: "Initialized",
      Progerssing: "Processing",
      Finished: "Finished",
      Error: "Error",
      Deleted: "Deleted",
      WaitingToBeConfirmed: "Waiting for confirmation",
    },
    Placeholder: {
      Code: "Enter transaction code",
      ID: "Enter transaction ID",
      TransRef: "Enter reference code",
    },
    Columns: {
      ID: "Transaction ID",
      Code: "Transaction code",
      TransRef: "Reference code",
      PackageName: "Package name",
      Phone: "Phone number",
      RegisteredPhone: "Registered subscription",
      Partner: "Partner",
      Method: "Method",
      TotalAmount: "Total amount",
    },
  },
  AddressManagement: {
    Title: "Province Management",
    DataType: "List Data",
    Province: "List of Provinces, Major Cities",
    District: "List of Districts, Counties",
    Wards: "List of Wards, Communes",
    Columns: {
      Name: "Name",
      Code: "Code",
      FullName: "Full Name",
      FullNameEn: "Full English Name",
      Province: "Province, Major Cities",
      District: "District, Counties",
      NameEn: "English Name",
      Ward: "Ward, Commune",
    },
    Placeholder: {
      Units: "Please select type",
      Regions: "Please select region",
    },
  },
  ChangePassword: {
    Title: "Change Password",
    OldPass: "Old Password",
    NewPass: "New Password",
    Reconfirmed: "Confirm New Password",
    Message: {
      InvalidPass: "Please confirm password",
      OldPass: "Please enter old password",
      NewPass: "Please enter new password",
      UnmatchedPass: "The confirmed password does not match",
      ChangePassSucceed: "You have successfully changed your password!",
    },
  },
  SimOrdersForPartners: {
    Title: "List of Sim registration information",
    OrderInfo: "Order information",
    Columns: {
      CreatedAt: "Time created",
      OrderCode: "Order code",
      Sim: "Sim number",
      Serial: "Serial number",
      PackageType: "Package type",
      CustomerName: "Customer name",
      CustomerPhone: "Customer phone number",
      Address: "Delivery address",
      Email: "Customer email",
      Partner: "Partner",
      Status: "Status",
      Detail: "Order details",
      ActivatedTime: "Activated Time",
      ConnectedTime: "Connected Time",
      Type: "Type",
      Name: "Name",
      TotalAmount: "Total Amount",
      PhoneNumber: "Phone number",
      SimItems: "Sim items",
    },
    Status: {
      WaitingForPurchased: "Waiting for payment",
      WaitingForDelivered: "Waiting for delivery",
      WaitingForRecieved: "Waiting for receipt",
      Success: "Delivery successful",
      Canceled: "Cancelled",
      ConnectedSuccessfully: "Connection successful",
      ConnectedFailed: "Connection failed",
      Items: {
        Import: "Imported",
        Export: "Exported",
        Connected: "Connected",
        Activated: "Activated",
        Destroyed: "Destroyed",
        Held: "Held",
      },
      Order: {
        Init: "Initialized",
        Progress: "In Progress",
        Finished: "Successful",
        Error: "Error",
        Deleted: "Canceled",
        ShippingOrder: "Shipping",
        WaitingPayment: "Waiting for Payment",
      },
    },
    Type: {
      Init: "Initialized",
      Active: "Activated",
      Kyc: "Connected",
      Transfer: "Warehouse Transfer",
    },
    Message: {
      ExcelError: "Error exporting report",
      InvalidSim: "Sim number cannot be blank",
      InvalidPackages: "Enter sim number to display package information",
      InvalidOrderCode: "Order code cannot be blank",
      InvalidPhone:
        "Contact phone number cannot be blank or more than 10 digits!",
      Address: "Please enter customer address",
    },
  },
  TravelSimListManagement: {
    Title: "Travel Sim Registration Information",
    Placeholder: "Please Enter",
    Detail: "Detailed Information",
    Gender: {
      Male: "Male",
      Female: "Female",
      Other: "Others",
    },
    Labels: {
      ProfileStatus: "The status of current profile is",
      BrightnessScore: "Brightness score:",
      OCRNow: "OCR the portrait, biodata page and videocall",
      Status: "Status",
      Type: "Paper type",
      Name: "Customer Name",
      ProfileId: "Profile Code",
      Serial: "Serial Number",
      Sim: "Sim Number",
      Detail: "Details",
      Time: "Creation Time",
      IdNumber: "Identification",
      Birthday: "Date of Birth",
      Sex: "Gender",
      Address: "Address",
      PlaceOfOrigin: "Birthplace",
      IssueDate: "Date of Issue",
      IssuePlace: "Place of Issue",
      PhoneContact: "Phone Number",
      EmailContact: "Email",
      ImagesPath: "Types of Documents",
      DialCode: "Area",
      Nationality: "Nationality",
      ConnectedTime: "Connection Time",
      Reason: "Reason",
      DownloadFile: "Download images",
      UpdateStatus: "Update profile's status",
      Connect: "Profile connection",
      CreateProfile: "Create profile",
      VideocallGenate: "Generate videocall",
      SubmitInfo: "Submit information",
      ConfirmInfo: "Confirm information",
      UploadImage: "Upload an image",
      UploadNote: "Select a file to upload",
      UploadHint: "Only one image can be uploaded",
      UploadAgain: "Choose another image",
      Passport: "Passport",
      Portrait: "Portrait",
      Videocall: "Videocall",
      QRSim: "Sim image",
      SignPad: "Digital signature",
      ClearSignature: "Clear signature",
      Complete: "Complete",
      SelectVideocall: "Select videocall",
      SignDirect: "Directly sign",
      UploadSign: "Upload signature",
      SimTracking: "Sim Tracking",
      Platform: "Platform",
      UploadMultiple: "Upload multiple profiles",
      Images: "Images",
      MissingImages: "Missing images list",
      ViewMultipleFile: "View uploaded multiple files",
    },
    ImagePaths: {
      portrait: "Portrait",
      videocall: "Videocall",
      front: "Biodata passport page",
      back: "Back",
      sign: "Digital signature",
      sim: "Sim",
      contract: "Contact",
      policy: "Policy",
      front_downscale: "Biodata page downscale",
      portrait_downscale: "Portrait downscale",
      videocall_downscale: "Video call downscale",
    },
    Status: {
      init: "Initialized",
      isOCR: "OCRed",
      verified: "Verified",
      progress: "Processing",
      success: "Successful",
      error: "Failed",
      sample: "Sample profile",
      activated: "Activated",
    },
    Type: {
      cccd: "Citizen Identification Card",
      passport: "Passport",
    },
    Platform: {
      multiple: "Multiple",
      single: "Single",
    },
    Message: {
      OcrSuccess: "OCRed successfully, profile detail is updated !",
      ProfileError:
        "Profile's status is FAILED, please OCR to update information !",
      InvalidPicture: "Please import at least 1 image file !",
      InvalidPhone: "Phone number must be at least 6 digits !",
      InvalidEmail: "Please enter a valid email address !",
      Nation: "Please choose your nationality",
      InvalidNation:
        "Please choose nationality to display value at place of issue and birthplace",
      ConnectSuccessfully: "Connected successfully",
      ConnectFailed: "Connected failed",
      AutofillwithNation: "Choose nationality to update value",
      EmptyField: "Please fill in all the required fields",
      SignatureError: "No digital signature found !",
      InvalidPortrait: "Invalid portrait photo!",
      InvalidFront: "Invalid passport / ID card photo!",
      NationalityNote: 'Autofill based on "Nationality"',
      DateError: "The date must be after the current date",
      OCRSuccess: "OCR successfully",
      CreateSuccess: "Profile created successfully",
      CancelCreateConfirm:
        "Are you sure you want to cancel creating a profile?",
      CreateDescription: "Create a profile for hand connection",
      ConnectDescription: "Directly connect the profile",
      LowBrightnessScore:
        "Brightness of passport, portrait photo or videocall did not meet the requirements !",
      Brightness: {
        front: "Brightness of the passport photo did not meet the requirements",
        portrait: "Brightness of portrait photo did not meet the requirements",
        videocall: "Brightness of the videocall did not meet the requirements",
      },
      UploadMultipleSuccess: "Uploaded successfully",
      UploadMultipleError: "Please choose a file with .zip, .rar, .tar format",
      AddMissingImages: "Please add missing images",
      Reason: "Please field in the reason",
    },
    TrackingResult: {
      ProfileNotFound: "Not found",
      ProfileNotRegistered: "Not registered.",
      NotVerified: "Information not verified",
      Verified: "Information verified",
      Progressing: "Processing",
      Success: "Registration successful",
      Fail: "Registration failed",
      Activated: "Sim activated (successfully called 900)",
      Inactivated: "Sim not activated (please call 900 to activate)",
    },
    TrackingMessage: {
      ProfileNotFound:
        "Your profile was not found. Please check the search information!",
      ProfileNotRegistered: "Sim has not been registered.",
      NotVerified: "Profile information not verified",
      Verified: "Profile information verified",
      Progressing: "Your profile is being processed",
      Success: "Your profile has been successfully registered",
      Fail: "Your profile registration has failed",
      Nation: "Please choose your country",
      NationalityNote: 'Autofill based on "Nationality"',
      NoProfileOrImage:
        "Registration tracking required Profile ID or Sim image",
      Activated:
        "Your sim is activated, information has been confirmed through 900",
      Inactivated:
        "Your sim is not activated, information has not been confirmed through 900)",
    },
  },
  RoamingRegistration: {
    Title: "Register for User",
    ModalTitle: "Register for Subscriber",
    Action: "Select Package",
    Phone: "Phone number needs to be registered",
    Register: "Register",
    PhoneRegisteredListColumns: {
      Name: "Customer Name",
      Phone: "Subscriber",
      Address: "Address",
      Price: "Total Amount",
      Email: "Email",
    },
    Columns: {
      Name: "Name",
      Code: "Code",
      Type: "Type",
      Duration: "Duration",
      Capacity: "Capacity",
      Price: "Price",
    },
    Placehoder: {
      Phone: "Please enter phone number...",
    },
    Message: {
      Success:
        "Subscription package registration for the subscriber is successful!",
      Failed: "Subscription package registration for the subscriber is failed",
      Error: "An error occurred",
      InvalidPackageAndPhone:
        "Please select a package and enter the subscriber to register!",
      InvalidPackage: "Please select a package!",
      InvalidPhone:
        "Please enter the subscriber number to register the package!",
      RegisterSuccessfully:
        "Subscription package registration for the subscriber is successful!",
      PhoneRegistrationWarning:
        "Please enter the subscriber number to register to display the list of suitable packages",
      PhoneRegistrationConfirm: "Confirm registration package",
      ForPhone: "for subscribers",
      BasePackagesExisted: "Subscriber currently has a base package",
      RemoveBasePackages:
        "Please cancel the base package before registering for a new package!",
      PackagesForSearchedPhone: "List of packages for subscribers",
    },
  },
  VideoGeneration: {
    Labels: {
      Prompt: "Desire",
      ImageNumber: "Amount of created images",
      NumberFielity: "Number of fielity",
      NativePrompt: "Undesired",
      Generate: "Generate videocalls",
      Regenerate: "Regenerate videocalls",
      Results: "Results",
      ChooseImage: "Choose this image",
      Chosen: "Chosen !",
    },
    Placeholder: {
      Prompt: "Things you desire when creating an image",
      NativePrompt: "Things you do not desire when creating an image",
      LesserThree: "Please choose the amount from 1 to 3",
    },
  },
  ProductManagement: {
    Title: "Product Management",
    Product: "Product",
    PackageInfo: "Package Information",
    Type: {
      MobileData: "Mobile Data",
      Sim: "Sim",
    },
    Status: {
      Active: "Active",
      Inactive: "Inactive",
      Deleted: "Deleted",
    },
    Currency: {
      VND: "VND",
      USD: "USD",
    },
    Labels: {
      Name: "Product Name",
      Code: "Product Code",
      Price: "Price",
      ProductCode: "Package Code",
      PriceForPartners: "Price for partners",
    },
  },
};
